module.exports = __webpack_public_path__ + "img/gi_ulartambah.724caf7e.png";